import { config } from 'util/config';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function openManageActionPack({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ manageActionPackShow: true, currentSubJobResultOption: parameter });
  pageComponent.getJobTypeData();
  pageComponent.getActionPackData();
}
